
import { Course } from '../types';

export const urgent_hearings: Course = {
  id: "urgent_hearings",
  title: "Urgent Hearings",
  description: "How to handle 'Without Notice' applications and immediate safety risks.",
  icon: "🚑",
  totalModules: 11,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/urgent_hearings/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "Which of the following scenarios typically qualifies as 'True Urgency' for an urgent family court application?",
        "o": [
            "A single missed weekend with a child.",
            "A late handover of a child.",
            "A significant risk of child abduction.",
            "A child's missed birthday."
        ],
        "a": 2
    },
    {
        "q": "What is the primary role of a 'Gatekeeping Judge' in the urgent application process?",
        "o": [
            "To issue the final decision in the case.",
            "To conduct the 'Without Notice' hearing with all parties present.",
            "To be the first person to review the application and determine its validity for urgent status.",
            "To mediate between the parties before the hearing."
        ],
        "a": 2
    },
    {
        "q": "According to the 'Duty of Full and Frank Disclosure' in urgent family court applications, what ethical burden is placed on the applicant?",
        "o": [
            "To only present facts that strongly support their own case.",
            "To avoid disclosing any information that might help the absent parent's case.",
            "To tell the Judge everything, including facts that might explicitly help the absent parent's case.",
            "To inform the absent parent of the hearing details before it takes place."
        ],
        "a": 2
    },
    {
        "q": "After an urgent 'Without Notice' hearing grants a temporary order, within what timeframe must a two-sided 'Return Date' typically occur?",
        "o": [
            "Within 24 hours.",
            "Within 7-14 days.",
            "Within 30 days.",
            "Within 6 months."
        ],
        "a": 1
    },
    {
        "q": "What is a significant consequence of filing an urgent application for a minor issue like a missed birthday or a late handover?",
        "o": [
            "It guarantees the application will be fast-tracked regardless of merit.",
            "It strengthens the applicant's credibility with the Judge.",
            "It may lead to financial cost orders against the applicant and damage their credibility.",
            "It automatically results in a permanent order in the applicant's favor."
        ],
        "a": 2
    }
]
};
